// src/mazot-takip/src/pages/YakitExcelYukle.js
import React, { useEffect, useMemo, useState } from "react";
import * as XLSX from "xlsx";
import { db, auth } from "../firebaseConfig";
import {
  collection, getDocs, addDoc, query, where, serverTimestamp, Timestamp,
} from "firebase/firestore";

/* ====================== ROL / İZİN ====================== */
const ROLES = { VIEW:"view", ONLY_INPUT:"only_input", INPUT_APPROVE:"input_approve", CREATOR:"creator" };

async function fetchUserMazotRole(email){
  try{
    if(!email) return ROLES.VIEW;
    const { getDoc, doc } = await import("firebase/firestore");
    const snap1=await getDoc(doc(db,"users",email)); let data=snap1.exists()?snap1.data():null;
    if(!data){
      const snap2=await getDocs(query(collection(db,"users"),where("email","==",email)));
      if(!snap2.empty) data=snap2.docs[0].data();
    }
    const m=data?.["mazot-takip"]||data?.["mazot_takip"]||{};
    if(m.olusturucu) return ROLES.CREATOR;
    if(m.giren_onaylayan) return ROLES.INPUT_APPROVE;
    if(m.giren) return ROLES.ONLY_INPUT;
    if(m.izleyen) return ROLES.VIEW;
    return ROLES.VIEW;
  }catch{ return ROLES.VIEW; }
}

/* ====================== YARDIMCI FONKSİYONLAR ====================== */
const sleep = (ms)=>new Promise(r=>setTimeout(r,ms));

function normalizeTR(s=""){return s.toString().toUpperCase()
  .replaceAll("İ","I").replaceAll("ı","I").replaceAll("Ş","S").replaceAll("ş","S")
  .replaceAll("Ğ","G").replaceAll("ğ","G").replaceAll("Ü","U").replaceAll("ü","U")
  .replaceAll("Ö","O").replaceAll("ö","O").replaceAll("Ç","C").replaceAll("ç","C")
  .trim().replace(/\s+/g," ");}

// Diakritikleri KORUYAN Türkçe büyük harf (tesis eşleştirmesi için)
function upTR(s=""){ return s.toString().toLocaleUpperCase("tr-TR").trim().replace(/\s+/g," "); }

function normKey(s=""){
  // Başlık karşılaştırmalarında kullan (diakritiklerden bağımsız anahtar)
  return normalizeTR(s).replace(/[^A-Z0-9]/g,"");
}

function normalizePlate(p){ return normalizeTR(p).replace(/\s+/g,"").replace(/[^A-Z0-9]/g,""); }
function normalizeReceipt(s=""){
  return String(s || "")
    .toUpperCase()
    .replace(/\s+/g, "")   // ❌ BOŞLUK YOK
    .trim();
}


function parseLiters(val){
  if(val==null) return NaN;
  if(typeof val==="number") return val;
  const s=String(val).trim().replace(/\s+/g,"").replace(",",".");
  const n=parseFloat(s);
  return Number.isFinite(n)? n : NaN;
}

function parseKm(val){
  if(val==null) return NaN;
  if(typeof val==="number") return Math.round(val);
  const s=String(val).trim().replace(/[.\s,]/g,"");
  const n=parseInt(s,10);
  return Number.isFinite(n)? n : NaN;
}

function noon(d){ const x=new Date(d); x.setHours(12,0,0,0); return x; }

function excelDateToJS(v){
  if(typeof v==="number"){ // Excel serial
    const d=new Date(Math.round((v-25569)*86400*1000));
    return noon(d);
  }
  if(v instanceof Date && !isNaN(v.getTime())) return noon(v);
  const raw=String(v||"").trim();
  if(!raw) return new Date("1900-01-01T12:00:00");
  const norm=raw.replace(/[./]/g,"-");
  let m = norm.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/); // yyyy-mm-dd
  if(m){ return noon(new Date(Number(m[1]),Number(m[2])-1,Number(m[3]))); }
  m = norm.match(/^(\d{1,2})-(\d{1,2})-(\d{2,4})$/); // dd-mm-(yy)yy
  if(m){
    const yyyy = m[3].length===2 ? Number("20"+m[3]) : Number(m[3]);
    return noon(new Date(yyyy, Number(m[2])-1, Number(m[1])));
  }
  const d=new Date(norm);
  return isNaN(d.getTime()) ? new Date("1900-01-01T12:00:00") : noon(d);
}

function getVal(row, keys, headerMap){
  // 1) Doğrudan eşleşme
  for(const k of keys){ if(row[k]!=null && String(row[k]).trim()!=="") return row[k]; }
  // 2) Normalize edilmiş başlık üzerinden eşleşme
  for(const k of keys){
    const real = headerMap.get(normKey(k));
    if(real && row[real]!=null && String(row[real]).trim()!=="") return row[real];
  }
  // 3) Heuristik: içeriyor mu?
  const heur = [
    ["PERSONEL","SOFOR","SURUCU"],
    ["PLAKA","ARAC"],
    ["LT","LITRE"],
    ["KM","KILOMETRE"],
    ["TARIH","DATE"],
    ["FIS","MAKBUZ","RECEIPT"],
    ["TESIS","TANK","YAKIT"] // tesis için
  ];
  const want = normKey(keys[0]); // ilk anahtarın niyeti
  for(const hk of headerMap.keys()){
    const hit = heur.some(group => group.every(g => hk.includes(g)) && want.includes(group[0]));
    if(hit){
      const real = headerMap.get(hk);
      if(real && row[real]!=null && String(row[real]).trim()!=="") return row[real];
    }
  }
  return "";
}

/* ====================== VERİ ÇEKİCİLER (DolumEkle ile uyumlu) ====================== */
async function fetchActivePlates(){
  const snap=await getDocs(query(collection(db,"plates"), where("active","==",true)));
  return snap.docs.map(d=>({id:d.id, ...(d.data()||{})}))
    .map(x=>({ id:x.id, plate:(x.plate||"").toUpperCase(), vehicleTesis:x.tesis||"" }))
    .filter(x=>x.plate)
    .sort((a,b)=>a.plate.localeCompare(b.plate,"tr"));
}

function tsToMsAny(v){
  if(!v) return null;
  if (v.toDate) return v.toDate().getTime();
  if (typeof v.seconds==="number") return v.seconds*1000;
  if (typeof v==="string"){
    const s=v.trim();
    let m=s.match(/^(\d{1,2})[.\-](\d{1,2})[.\-](\d{4})$/);
    if(m){ const dd=m[1].padStart(2,"0"), MM=m[2].padStart(2,"0"), yyyy=m[3]; const d=new Date(`${yyyy}-${MM}-${dd}T12:00:00`); return isNaN(d.getTime())?null:d.getTime(); }
    m=s.match(/^(\d{4})[.\-](\d{1,2})[.\-](\d{1,2})$/);
    if(m){ const d=new Date(`${m[1]}-${String(m[2]).padStart(2,"0")}-${String(m[3]).padStart(2,"0")}T12:00:00`); return isNaN(d.getTime())?null:d.getTime(); }
  }
  const d=new Date(v); return isNaN(d.getTime())?null:d.getTime();
}

function isActivePersonStrict(p){
  if(typeof p.active==="boolean") return p.active;
  const tarih = p.tarih && typeof p.tarih==="object" ? p.tarih : null;
  if(tarih){
    const ins = Object.keys(tarih).filter(k=>/^giris/i.test(k));
    const outs= Object.keys(tarih).filter(k=>/^cikis/i.test(k));
    if(ins.length!==outs.length) return ins.length>outs.length;
    let lastIn=null,lastOut=null;
    ins.forEach(k=>{ const ms=tsToMsAny(tarih[k]); if(ms!=null) lastIn = lastIn==null?ms:Math.max(lastIn,ms); });
    outs.forEach(k=>{ const ms=tsToMsAny(tarih[k]); if(ms!=null) lastOut= lastOut==null?ms:Math.max(lastOut,ms); });
    if(lastIn!=null || lastOut!=null){
      if(lastOut==null) return true;
      if(lastIn==null) return false;
      return lastIn>lastOut;
    }
  }
  const ins=[p.sonGiris,p.girisTarihi,p.iseGiris,p.giris,p.startDate];
  const outs=[p.sonCikis,p.cikisTarihi,p.istenCikis,p.cikis,p.endDate];
  let li=null, lo=null;
  ins.forEach(v=>{ const ms=tsToMsAny(v); if(ms!=null) li=li==null?ms:Math.max(li,ms); });
  outs.forEach(v=>{ const ms=tsToMsAny(v); if(ms!=null) lo=lo==null?ms:Math.max(lo,ms); });
  if(li==null&&lo==null) return true;
  if(li!=null&&lo==null) return true;
  if(li==null&&lo!=null) return false;
  return li>lo;
}

const xName = (p)=>`${p.ad}${p.soyad? " "+p.soyad : ""}`;

async function fetchActivePeople(){
  const snap=await getDocs(collection(db,"personeller"));
  const all = snap.docs.map(d=>({id:d.id, ...(d.data()||{})}));
  return all.filter(isActivePersonStrict)
    .map(x=>({ id:x.id, ad:x.ad||"", soyad:x.soyad||"" }))
    .filter(x=>x.ad)
    .sort((a,b)=>`${xName(a)}`.localeCompare(`${xName(b)}`,"tr"));
}

// fuel_tanks → Map(UP_TR(tesis) -> ilk tankId)
async function buildTankIdByTesis(){
  const map = new Map();
  try{
    const snap = await getDocs(collection(db,"fuel_tanks"));
    snap.docs.forEach(d=>{
      const data = d.data()||{};
      const tesis = upTR(data.tesis||"");
      if(!tesis) return;
      if(!map.has(tesis)) map.set(tesis, d.id); // aynı tesis adı için ilk tank
    });
  }catch{}
  return map;
}

/* ====================== ANA BİLEŞEN ====================== */
export default function YakitExcelYukle(){
  const [dosya,setDosya]=useState(null);
  const [progress,setProgress]=useState(0);
  const [hataDosyasiAktif,setHataDosyasiAktif]=useState(true);
  const [loading,setLoading]=useState(false);

  const [plates,setPlates]=useState([]);
  const [people,setPeople]=useState([]);
  const [role,setRole]=useState(ROLES.VIEW);
  const [tankIdByTesis,setTankIdByTesis]=useState(new Map());

  useEffect(()=>{
    fetchUserMazotRole(auth.currentUser?.email).then(setRole);
    Promise.all([fetchActivePlates(), fetchActivePeople(), buildTankIdByTesis()])
      .then(([pl,pe,tmap])=>{ setPlates(pl); setPeople(pe); setTankIdByTesis(tmap); });
  },[]);

  const allowedPlateSet = useMemo(()=>{
    const s=new Set(); plates.forEach(p=>s.add(normalizePlate(p.plate))); return s;
  },[plates]);

  const vehicleTesisByPlate = useMemo(()=>{
    const m=new Map(); plates.forEach(p=>m.set(normalizePlate(p.plate), p.vehicleTesis||"")); return m;
  },[plates]);

  const personLabelMap = useMemo(()=>{
    const m=new Map(); people.forEach(pe=>m.set(normalizeTR(xName(pe)), pe)); return m;
  },[people]);

  const canCreate = [ROLES.ONLY_INPUT, ROLES.INPUT_APPROVE, ROLES.CREATOR].includes(role);

  const handleOrnekIndir=()=>{
    const wb=XLSX.utils.book_new();
    const veri=[{
      "Personel Adı":"Ali Veli",
      "Plaka":"06BJE696",
      "LT":"125,5",
      "KM":"123.456",
      "Tarih":"12.08.2025",
      "Fiş No":"GUV-000123",
      "Tesis":"GÜVERCİNLİK"
    }];
    const ws=XLSX.utils.json_to_sheet(veri);
    XLSX.utils.book_append_sheet(wb, ws, "Yakit");
    XLSX.writeFile(wb, "ornek_yakit.xlsx");
  };

  const handleDosyaSec=(e)=>setDosya(e.target.files[0]);

  const handleYukle=()=>{
    if(!dosya) return alert("Lütfen bir Excel dosyası seçin.");
    if(!canCreate) return alert("Bu işlem için yetkiniz yok.");
    setLoading(true); setProgress(0);

    const reader=new FileReader();
    reader.onload=async (ev)=>{
      try{
        const wb=XLSX.read(ev.target.result, { type:"binary" });
        const ws=wb.Sheets[wb.SheetNames[0]];
        const rows=XLSX.utils.sheet_to_json(ws, { defval:"", raw:true });

        if(!rows.length){ alert("Excel dosyası boş veya şablon hatalı."); setLoading(false); return; }

        // --- Başlıkları normalize edip bir kez eşleştir ---
        const headerMap = new Map(); // norm -> gerçek başlık
        Object.keys(rows[0]).forEach(k => headerMap.set(normKey(k), k));

        // Zorunlu kolonlar (TESİS dahil)
        const requiredGroups = {
          person: ["Personel Adı","Personel","Şoför","Sürücü"],
          plate:  ["Plaka","Araç","Araç Plaka"],
          lt:     ["LT","Lt","lt","Litre","LİTRE"],
          km:     ["KM","Km","km","Kilometre"],
          date:   ["Tarih","TARİH","Date","DATE"],
          receipt:["Fiş No","Fis No","FisNo","FIS NO","FISNO","Makbuz","Makbuz No","Receipt","Receipt No"],
          tesis:  ["Tesis","Yakıt Tesisi","Tank","Yakıt"]
        };
        const missing = [];
        for(const [k,arr] of Object.entries(requiredGroups)){
          const ok = arr.some(a => headerMap.has(normKey(a)) || Object.prototype.hasOwnProperty.call(rows[0], a));
          if(!ok) missing.push(k);
        }
        if(missing.length){
          alert(
            "Şu zorunlu kolon(lar) bulunamadı:\n" +
            missing.map(m=>(
              m==="person" ? "Personel Adı/Personel/Şoför/Sürücü" :
              m==="plate"  ? "Plaka/Araç/Araç Plaka" :
              m==="lt"     ? "LT/Litre" :
              m==="km"     ? "KM/Kilometre" :
              m==="date"   ? "Tarih/Date" :
              m==="receipt"? "Fiş No (Fiş No/Fis No/FisNo/Makbuz/Receipt)" :
                             "Tesis (Tesis/Yakıt Tesisi/Tank/Yakıt)"
            )).join("\n")
          );
          setLoading(false); return;
        }

        // 1) Parse & normalize (TESİS dahil; diakritik KORU)
        const parsed = rows.map((row,idx)=>{
          const person = normalizeTR(getVal(row, requiredGroups.person, headerMap)); // personel label map böyleydi
          const plate  = normalizePlate(getVal(row, requiredGroups.plate, headerMap));
          const lt     = parseLiters(getVal(row, requiredGroups.lt, headerMap));
          const km     = parseKm(getVal(row, requiredGroups.km, headerMap));
          const date   = excelDateToJS(getVal(row, requiredGroups.date, headerMap));
          const receipt= normalizeReceipt(getVal(row, requiredGroups.receipt, headerMap));
          const tesis  = upTR(getVal(row, requiredGroups.tesis, headerMap)); // diakritikli-tr upper
          return { __row: idx+2, raw: row, person, plate, lt, km, date, receipt, tesis };
        });

        // 2) Temel validasyonlar + sözlük kontrolü (TESİS zorunlu)
        const hatali=[]; const adayBase=[];
        for(const r of parsed){
          if(!r.person || !r.plate || isNaN(r.lt) || isNaN(r.km) || isNaN(r.date.getTime()) || !r.receipt || !r.tesis){
            hatali.push({ ...r.raw, "Hata Nedeni":"Zorunlu alan(lar) eksik/yanlış (Personel/Plaka/LT/KM/Tarih/Fiş No/Tesis)", "__Satır": r.__row }); continue;
          }
          if(!personLabelMap.has(r.person)){
            hatali.push({ ...r.raw, "Hata Nedeni":`Personel bulunamadı: ${r.person}`, "__Satır": r.__row }); continue;
          }
          if(!allowedPlateSet.has(r.plate)){
            hatali.push({ ...r.raw, "Hata Nedeni":`Plaka bulunamadı: ${r.plate}`, "__Satır": r.__row }); continue;
          }

// ✅ TESİS DB KONTROLÜ (fuel_tanks içinde tank tanımı olmalı)
if (!tankIdByTesis.has(r.tesis)) {
  hatali.push({
    ...r.raw,
    "Hata Nedeni": `Geçersiz tesis (tank tanımı yok): ${r.tesis}`,
    "__Satır": r.__row
  });
  continue;
}

          if(r.lt<=0){ hatali.push({ ...r.raw, "Hata Nedeni":"LT sıfırdan büyük olmalı", "__Satır": r.__row }); continue; }
          if(r.km<0){ hatali.push({ ...r.raw, "Hata Nedeni":"KM negatif olamaz", "__Satır": r.__row }); continue; }
          adayBase.push(r);
        }
        if(!adayBase.length){
          alert(`Yüklenebilir satır yok. Hatalı: ${hatali.length}`);
          if(hataDosyasiAktif && hatali.length){
            const wb2=XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb2, XLSX.utils.json_to_sheet(hatali), "Hatalar");
            XLSX.writeFile(wb2, "yakit_yukleme_hatalari.xlsx");
          }
          setLoading(false); return;
        }

        // 3) Fiș No – Dosya içi mükerrer kontrolü
        const cnt = adayBase.reduce((m,r)=>{ m[r.receipt]=(m[r.receipt]||0)+1; return m; }, {});
        const dupInFile = new Set(Object.keys(cnt).filter(k=>cnt[k]>1));

        const adayNoDupFile=[]; const rejectedByDupFile=[];
        for(const r of adayBase){
          if(dupInFile.has(r.receipt)){
            rejectedByDupFile.push({ ...r.raw, "Hata Nedeni":`Fiş No bu dosyada mükerrer: ${r.receipt}`, "__Satır": r.__row });
          }else{
            adayNoDupFile.push(r);
          }
        }
        if(!adayNoDupFile.length){
          const totalErr=[...hatali, ...rejectedByDupFile];
          alert(`Tüm satırlar dosya içi Fiş No mükerrer. Hatalı: ${totalErr.length}`);
          if(hataDosyasiAktif && totalErr.length){
            const wb2=XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb2, XLSX.utils.json_to_sheet(totalErr), "Hatalar");
            XLSX.writeFile(wb2, "yakit_yukleme_hatalari.xlsx");
          }
          setLoading(false); return;
        }

        // 4) Fiș No – Veritabanı mükerrerleri
        const uniqueReceipts = Array.from(new Set(adayNoDupFile.map(r=>r.receipt)));
        const existingReceipts = new Set();
        const CHUNK = 10; // Firestore 'in' max 10
        for(let i=0;i<uniqueReceipts.length;i+=CHUNK){
          const part=uniqueReceipts.slice(i,i+CHUNK);
          try{
            const snap=await getDocs(query(collection(db,"fuel_transactions"), where("receiptNo","in",part)));
            snap.docs.forEach(d=>{
              const v = d.data()?.receiptNo;
              if(v) existingReceipts.add(String(v).toUpperCase());
            });
          }catch{ /* index yoksa yoksay */ }
        }

        const aday=[]; const rejectedByDupDb=[];
        for(const r of adayNoDupFile){
          if(existingReceipts.has(r.receipt)){
            rejectedByDupDb.push({ ...r.raw, "Hata Nedeni":`Fiş No veritabanında kayıtlı: ${r.receipt}`, "__Satır": r.__row });
          }else{
            aday.push(r);
          }
        }
        if(!aday.length){
          const totalErr=[...hatali, ...rejectedByDupFile, ...rejectedByDupDb];
          alert(`Tüm satırlar Fiş No mükerrer (veritabanı). Hatalı: ${totalErr.length}`);
          if(hataDosyasiAktif && totalErr.length){
            const wb2=XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb2, XLSX.utils.json_to_sheet(totalErr), "Hatalar");
            XLSX.writeFile(wb2, "yakit_yukleme_hatalari.xlsx");
          }
          setLoading(false); return;
        }

        // 5) Plakaya göre grupla, tarih sırala (KM tutarlılığı için)
        const byPlate=new Map();
        aday.forEach(r=>{ if(!byPlate.has(r.plate)) byPlate.set(r.plate, []); byPlate.get(r.plate).push(r); });
        for(const arr of byPlate.values()){ arr.sort((a,b)=>a.date-b.date); }

        // 6) Veritabanından mevcut kayıtları topla (KM kıyası)
        const existingByPlate=new Map();
        for(const plate of byPlate.keys()){
          const list=[];
          const snap=await getDocs(query(collection(db,"fuel_transactions"), where("vehiclePlate","==",plate)));
          snap.docs.forEach(d=>{
            const x=d.data()||{};
            const dt = x.date?.toDate?.() || new Date(x.date||0);
            const km = Number(x.odometerKm);
            if(!isNaN(dt.getTime()) && Number.isFinite(km)) list.push({ date: noon(dt), km });
          });
          list.sort((a,b)=>a.date-b.date);
          existingByPlate.set(plate, list);
        }

        // 7) KM tutarlılık (DB + aynı Excel birlikteliği)
        const accepted=[]; const rejectedKm=[];
        for(const [plate, arr] of byPlate.entries()){
          const base = existingByPlate.get(plate) || [];
          const excelPoints = arr.map(r=>({ date:r.date, km:r.km, __excel:r }));
          const union = [...base, ...excelPoints].sort((a,b)=>a.date-b.date);

        for(let i=0;i<union.length;i++){
            const u=union[i]; if(!u.__excel) continue;
            // strictly earlier
            let prevKm=null; for(let j=i-1;j>=0;j--){ if(union[j].date < u.date){ prevKm=union[j].km; break; } }
            // strictly later
            let nextKm=null; for(let j=i+1;j<union.length;j++){ if(union[j].date > u.date){ nextKm=union[j].km; break; } }

            const row=u.__excel;
            const badPrev = prevKm!=null && row.km < prevKm;
            const badNext = nextKm!=null && row.km > nextKm;

            if(badPrev || badNext){
              rejectedKm.push({
                ...row.raw,
                "Hata Nedeni": badPrev && badNext
                  ? `KM önceki (${prevKm}) ve sonraki (${nextKm}) değer aralığı dışında`
                  : badPrev ? `KM önceki kayıttan küçük (≥ ${prevKm} olmalı)`
                            : `KM sonraki kayıttan büyük (≤ ${nextKm} olmalı)`,
                "__Satır": row.__row
              });
            } else {
              accepted.push(row);
            }
          }
        }

        if(!accepted.length){
          const totalErr=[...hatali, ...rejectedByDupFile, ...rejectedByDupDb, ...rejectedKm];
          alert(`Tüm satırlar KM/Fiş kontrolünde elendi. Hatalı: ${totalErr.length}`);
          if(hataDosyasiAktif && totalErr.length){
            const wb3=XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb3, XLSX.utils.json_to_sheet(totalErr), "Hatalar");
            XLSX.writeFile(wb3, "yakit_yukleme_hatalari.xlsx");
          }
          setLoading(false); return;
        }

        // 8) Firestore'a yaz
        //    - tesis: Excel’deki değer (TR upper, diakritikli)
        //    - vehicleTesis: plakadan
        //    - tankId: tankIdByTesis.get(UP_TR(tesis))
        const status = [ROLES.CREATOR, ROLES.INPUT_APPROVE].includes(role) ? "approved" : "pending";
        const chunk=50; let written=0;
        for(let i=0;i<accepted.length;i+=chunk){
          const part=accepted.slice(i,i+chunk);
          await Promise.all(part.map(async (r)=>{
            const person = personLabelMap.get(r.person);
            const plateKey = normalizePlate(r.plate);
            const vehicleTesis = vehicleTesisByPlate.get(plateKey) || "";
            const tesisExcel  = upTR(r.tesis); // zaten upTR, tekrar güvence

            const tankId = tankIdByTesis.get(tesisExcel) ?? null;

            await addDoc(collection(db,"fuel_transactions"), {
              sourceType: "tank",
              tesis: tesisExcel,
              tankId,
              vehiclePlate: r.plate,
              vehicleTesis,
              driverId: person?.id || null,
              driverName: person ? xName(person) : null,
              date: Timestamp.fromDate(r.date),
              liters: r.lt,
              receiptNo: r.receipt,
              odometerKm: r.km,
              createdBy: auth.currentUser?.email || "excel",
              createdAt: serverTimestamp(),
              deleted: false,
              status,
            });
          }));
          written += part.length;
          setProgress(Math.min(100, Math.round(((i+chunk)/accepted.length)*100)));
          await sleep(120);
        }

        // 9) Özet & hata dosyası
        const totalErr=[...hatali, ...rejectedByDupFile, ...rejectedByDupDb, ...rejectedKm];
        alert(`✅ Yükleme tamamlandı\n✔ Başarıyla eklenen: ${written}\n❗ Hatalı satır: ${totalErr.length}`);
        setProgress(0);
        if(hataDosyasiAktif && totalErr.length){
          const wb4=XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb4, XLSX.utils.json_to_sheet(totalErr), "Hatalar");
          XLSX.writeFile(wb4, "yakit_yukleme_hatalari.xlsx");
        }
      }catch(err){
        console.error("Yükleme hatası:", err);
        alert("Bir hata oluştu. Konsola bak.");
      }finally{
        setLoading(false);
      }
    };
    reader.readAsBinaryString(dosya);
  };

  return (
    <div style={{ padding:20, maxWidth:880, margin:"auto" }}>
      <h2 style={{ fontSize:20, fontWeight:"bold", color:"#334155", marginBottom:14 }}>Excel ile Dolum Yükle</h2>

      <div style={{ display:"flex", gap:10, alignItems:"center", marginBottom:10 }}>
        <input type="file" accept=".xlsx,.xls" onChange={handleDosyaSec} disabled={loading}/>
        <button onClick={handleOrnekIndir}
          style={{ background:"#2563eb", color:"#fff", padding:"8px 12px", borderRadius:6, border:"none", cursor:"pointer" }}>
          Örnek Şablon
        </button>
      </div>

      <label style={{ display:"block", marginBottom:10 }}>
        <input type="checkbox" checked={hataDosyasiAktif} onChange={e=>setHataDosyasiAktif(e.target.checked)} disabled={loading}/> Hata Dosyası Oluştur
      </label>

      <button onClick={handleYukle} disabled={loading || !dosya || !canCreate}
        style={{ background:(!canCreate||!dosya||loading)?"#9ca3af":"#16a34a", color:"#fff", padding:"10px 16px", borderRadius:6, border:"none", cursor:(!canCreate||!dosya||loading)?"not-allowed":"pointer" }}>
        Yükle
      </button>

      {progress>0 && (
        <div style={{ marginTop:18 }}>
          <div style={{ background:"#e5e7eb", height:20, borderRadius:6, overflow:"hidden" }}>
            <div style={{ width:`${progress}%`, height:"100%", background:"#0ea5e9", transition:"width .3s" }}/>
          </div>
          <p style={{ marginTop:6 }}>{progress}% tamamlandı…</p>
        </div>
      )}

      {!canCreate && <p style={{ marginTop:10, color:"#b91c1c" }}>Bu sayfayı kullanmak için yetkiniz yok.</p>}
    </div>
  );
}
